import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-mist" data-id="element-321" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-322" data-mp="cng1oereb36u">
        <div className="text-center mb-16" data-id="element-323" data-mp="cm52ytct4lml">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-navy" data-id="element-324" data-mp="7p65q1xujyk6">
            THE 6-IN-1 SCUBA DIVING INSTRUCTOR <span className="text-cta" data-id="element-325" data-mp="3g5raf6jg45hh">READY</span> SYSTEM
          </h2>
          <p className="text-xl text-slate-700" data-id="element-326" data-mp="3c4fhos59z452">
            <span className="text-cta font-semibold" data-id="element-327" data-mp="3c1jkj6194jho">150 Ready-to-Teach Lessons</span> · Beginner to
            Advanced · Visual Teaching Tools · Nothing to Build From Scratch
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-328" data-mp="3l281a8i14xy9">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-cta shadow-lg shadow-navy/10' : 'border-slate-200 shadow-sm shadow-navy/5'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-329" data-mp="2xcngdk2bfqmc" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-38px] bg-cta text-white font-bold text-xs py-1 px-10 rotate-45 shadow" data-id="element-330" data-mp="1vfha139l4ekj">
                  MOST POPULAR
                </div>}

              <div className="flex items-center gap-4 mb-6 pr-10" data-id="element-331" data-mp="24g5sca60h138">
                <span className="w-12 h-12 rounded-xl bg-ocean text-white font-serif font-extrabold text-2xl flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-332" data-mp="24eb34jnpimtc">
                  {index + 1}
                </span>
                <div data-id="element-333" data-mp="1gp9fx2nmjkw3">
                  <div className="text-ocean font-bold text-sm uppercase tracking-wider" data-id="element-334" data-mp="1gsxb068pwfcx">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-navy" data-id="element-335" data-mp="1prr59pykstnb">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-navy font-semibold mb-6 border-l-4 border-aqua pl-4" data-id="element-336" data-mp="x221x5ye8hij">
                {volume.subtitle}
              </p>

              {(volume.intro.length > 0 || volume.questions || volume.highlight) && <div className="mb-6 space-y-2" data-id="element-337" data-mp="16u7rya534ov3">
                  {volume.intro.map(paragraph => <p key={paragraph} className="text-ink text-sm leading-relaxed" data-id="element-338" data-mp="120ddpm89123e">
                      {paragraph}
                    </p>)}
                  {volume.questions && <ul className="grid sm:grid-cols-2 gap-2 pt-1" data-id="element-339" data-mp="9czaj6dyjaau">
                      {volume.questions.map(question => <li key={question} className="text-ocean font-semibold text-sm bg-mist border border-aqua/30 rounded-lg px-3 py-2" data-id="element-340" data-mp="2prb3rhjhjwhe">
                          {question}
                        </li>)}
                    </ul>}
                  {volume.highlight && <p className="text-white font-bold text-base bg-navy border-l-4 border-cta rounded-lg px-4 py-3" data-id="element-341" data-mp="34mqxtmk2fsds">
                      {volume.highlight}
                    </p>}
                  {volume.afterHighlight && <p className="text-ink text-sm leading-relaxed" data-id="element-342" data-mp="2zo7dtrp18qo2">{volume.afterHighlight}</p>}
                </div>}

              <div data-id="element-343" data-mp="1oabyahu7ufwb">
                <div data-id="element-344" data-mp="1oav7991w1ty7">
                  <p className="text-navy font-semibold text-sm mb-3" data-id="element-345" data-mp="1obde0zm6fqkd">{volume.bulletsIntro}</p>
                  <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-346" data-mp="23l0i38ig5dgx">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-347" data-mp="1pueytip2z1ii">
                        <CheckCircle2 size={18} className="text-ocean shrink-0 mt-0.5" data-id="element-348" data-mp="2mhjldh6kk75k" />
                        <span className="text-ink text-sm" data-id="element-349" data-mp="2iiaseejcsdb2">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                {volume.secondaryBullets && <div data-id="element-350" data-mp="28ia6cku3nj36">
                    <p className="text-navy font-semibold text-sm mb-3" data-id="element-351" data-mp="28l63w821c5r3">
                      {volume.secondaryBulletsIntro}
                    </p>
                    <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start" data-id="element-352" data-mp="x3n5cszegqyv">
                      {volume.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-353" data-mp="my51yvnpwuwg">
                          <CheckCircle2 size={18} className="text-ocean shrink-0 mt-0.5" data-id="element-354" data-mp="rzcc31dc266a" />
                          <span className="text-ink text-sm" data-id="element-355" data-mp="wwkwz9pv8ob8">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>

              {volume.sequence && <div className="mb-6" data-id="element-356" data-mp="1apak5hh4rz9x">
                  <p className="text-navy font-semibold text-sm mb-2" data-id="element-357" data-mp="1ao940yl9cmlc">{volume.sequenceIntro}</p>
                  <p className="text-ocean font-bold text-sm bg-mist border border-aqua/30 rounded-lg px-3 py-2" data-id="element-358" data-mp="1fpyk4snc7qga">
                    {volume.sequence}
                  </p>
                </div>}

              <div className="bg-cream border border-cta/20 border-l-4 border-l-cta rounded-xl p-4 mt-auto" data-id="element-359" data-mp="3hhl44a8tal39">
                <span className="text-navy font-bold block mb-1" data-id="element-360" data-mp="3mfd4lsnivfj2">RESULT</span>
                {volume.resultLead && <p className="text-ink text-sm" data-id="element-361" data-mp="3eg8fraxceam3">
                    {volume.resultLead}{' '}
                    <span className="font-semibold text-navy" data-id="element-362" data-mp="39hovdeyed6vu">{volume.resultQuote}</span>
                  </p>}
                <p className="text-ink text-sm" data-id="element-363" data-mp="3jcyxs3spjga5">{volume.result}</p>
                {volume.resultEmphasis && <p className="mt-2 text-xl font-serif font-extrabold text-cta" data-id="element-364" data-mp="173qgpen28ah">
                    {volume.resultEmphasis}
                  </p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}